import { VFC } from 'react'
import { _feedbacksecondary, _feedbackstar } from 'src/styles/colors'
import { fontWeightRegular } from 'src/styles/font'
import styled from 'styled-components'
import { Rating } from '.'
import { TooltipWrapper } from '../Tooltip'

const RATING_STATIC_PROPS = {
  max: 5,
  char: '★',
  activeColor: _feedbackstar,
  inactiveColor: `${_feedbacksecondary}40`,
}
type FeedbackScoreProps = {
  value?: number
  feedbackCount?: number
  yValue?: string
}

export const FeedbackScore: VFC<FeedbackScoreProps> = ({
  value,
  feedbackCount,
  yValue,
}) => {
  if (!value || value < 0 || !feedbackCount || feedbackCount === 0) return <></>

  return (
    <>
      <FeedbackScoreDiv>
        <TooltipWrapper
          xValue={'-20px'}
          yValue={yValue ? yValue : '30px'}
          tooltipNode={
            <TooltipText>
              <div>
                評価ポイント：{value}
                <br />
                <br />
                ※他企業から高評価をうけている企業に表示されるロゴになります。
                <br />
                <br />
                ※本機能はβ版提供のため、アポイントの参考程度に感じていただけますと幸いです。
              </div>
            </TooltipText>
          }
          tooltipStyle={{
            width: '250px',
          }}
          isWrap
        >
          <Rating
            {...RATING_STATIC_PROPS}
            value={value}
            disabled
            isCenter={false}
          />
        </TooltipWrapper>
        <FeedbackScoreSpan>({feedbackCount})</FeedbackScoreSpan>
      </FeedbackScoreDiv>
    </>
  )
}

const FeedbackScoreDiv = styled.div`
  display: flex;
  align-items: center;
`

const FeedbackScoreSpan = styled.span`
  color: ${_feedbacksecondary};
  font-size: 14px;
  margin-left: 8px;
`
const TooltipText = styled.div`
  font-size: 14px;
  font-weight: ${fontWeightRegular};
`
